<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container-fluid">
      <div class="card bg-light mb-3">
        <center><h2 class="card-header">IRR Access Requests - {{ irr.name }}</h2>
        <p><small>ID # {{ irr.id }}</small></p></center>
        <div class="card-body">
          <div class="card-text">

            <div class="card">
              <table class="table table-sm table-hover table-borderless">
                <thead class="border-bottom">
                  <tr>
                    <th class="larger pl-3" scope="col">User</th>
                    <th class="larger" scope="col">Status</th>
                    <!--<th class="larger" scope="col">Submitted</th>
                    <th class="larger" scope="col">Last Updated</th>-->
                    <th class="larger" scope="col">&nbsp;</th> <!-- Column for button to accept the request -->
                    <th class="larger" scope="col">&nbsp;</th> <!-- Column for button to decline the request -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="accReq in accessRequests">
                    <th class="pl-3">{{accReq.display_name}}</th>
                    <th>{{requestStatus(accReq)}}</th>
                    <th>
                      <form v-if="accReq.pending" method="POST" :action="'/irr/' + irr.id + '/accessrequests/' + accReq.id + '/1'" style="display:inline;">
                        <input type="hidden" name="_token" :value="csrf_token">
                        <button type="submit" class="btn btn-info" role="button">Accept</button>
                      </form>
                    </th>
                    <th>
                      <form v-if="accReq.pending" method="POST" :action="'/irr/' + irr.id + '/accessrequests/' + accReq.id + '/0'" style="display:inline;">
                        <input type="hidden" name="_token" :value="csrf_token">
                        <button type="submit" class="btn btn-danger" role="button">Decline</button>
                      </form>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        permissions: Object,
        irr: Object,
        accessRequests: [Object, Array],
        csrf_token: String,
      },
      methods: {
        requestStatus: function (request) {
          return ( (request.pending) ? 'Pending' : ( (request.approved) ? 'Approved' : 'Declined') );
        }
      },
      mounted() {
        //
      }
    }
</script>
